module.exports = __webpack_public_path__ + "img/ic-date.b7bdaa20.svg";